import { specDisplay } from "@/lib/api";

/** Readable technical spec table. Unknown values are shown explicitly. */
export default function SpecTable({ fields = [], specs = {}, catalogSpecs, overriddenKeys = [], testId = "spec-table" }) {
  return (
    <div className="overflow-hidden rounded-md border border-black/[0.08]" data-testid={testId}>
      <table className="w-full text-sm border-collapse">
        <tbody>
          {fields.map((f, i) => {
            const v = specDisplay(f, specs?.[f.key]);
            const overridden = overriddenKeys.includes(f.key);
            return (
              <tr key={f.key} className={i % 2 ? "bg-black/[0.025]" : ""} data-testid={`spec-row-${f.key}`}>
                <th className="w-1/2 border-b border-black/[0.08] px-4 py-2.5 text-left font-normal text-zinc-500">{f.label}</th>
                <td className="border-b border-black/[0.08] px-4 py-2.5 font-mono text-[13px]">
                  {v ?? <span className="text-zinc-500 italic font-sans">Bilinmiyor</span>}
                  {overridden && (
                    <span className="ml-2 rounded bg-[#0071e3]/15 px-1.5 py-0.5 text-[10px] font-sans text-[#0077ed]"
                      title={`Katalog değeri: ${specDisplay(f, catalogSpecs?.[f.key]) ?? "Bilinmiyor"}`}>
                      satıcı değiştirdi
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
